// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"1d3654b0","541":"1d3654b0"}[chunkId] + ".chunk.css";
};